type DateLike = Date | string | number
export type CreatedDateItem = {createdOn: DateLike}

export enum EnvironmentEnum {
  PRODUCTION = 'production',
  STAGING = 'staging',
  DEVELOPMENT = 'development',
  DEPLOYMENT = 'deployment',
  TEST = 'test',
}

export interface HOC {
  children: React.ReactNode
}

export interface GenericMessageResponse {
  message: string
}

export interface TokenDataType {
  exp: number
}

export interface ObjectWithBooleanKeys {
  [key: string]: boolean
}

export interface ColumnSize {
  id: string
  width: number
}

export interface ResizingColumn {
  id: string
  startX: number
  startWidth: number
  widthAdjustmentApplied?: boolean
}

// UI tones/severity levels used across components
export enum UITone {
  Danger = 'danger',
  Warning = 'warning',
}

export type AlertBannerVariant = 'danger' | 'warning' | 'info' | 'success'

export type AlertBannerAction = {
  label: string
  onClick: () => void
  ariaLabel?: string
  disabled?: boolean
}

export enum DopeProduct {
  CASB = 'casb',
  DLP = 'dlp',
}

// Installer bundles supported across the app
export enum InstallerType {
  Mac = 'mac',
  Windows = 'windows',
  WindowsArm = 'windows-arm',
}

export enum SortOrderEnum {
  Ascending = 'asc',
  Descending = 'desc',
}
